module.exports = __webpack_public_path__ + "static/media/Eventxtra Virtual Platform_v8-17.c9ef786c.png";